var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 107,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 107
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 119,
    height: 107
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1511300,
    height: 1358900
  })), /*#__PURE__*/React.createElement("image", {
    width: 237,
    height: 213,
    xlinkHref: "data:image/jpeg;base64,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",
    preserveAspectRatio: "none",
    id: "img3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1511300,
    height: 1358257
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    transform: "scale(7.87402e-05 7.87402e-05)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    transform: "scale(1 1.00047)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img3",
    opacity: 1,
    transform: "scale(6376.79 6376.79)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.b1d924741faa3b2fdd670c239a0271f7.svg";
export { ForwardRef as ReactComponent };